import { reactSelectComponents } from '../reactSelectComponents';

import styles from '../Select.module.scss';

export const MultiValue = (props: any) => {
  const { index, getValue } = props;
  const { selectProps }: { [key: string]: any } = props;
  const { multiLabelWithNumber } = selectProps;

  if (multiLabelWithNumber) {
    if (index === 0) {
      return (
        <div className={styles.multiLabelWithNumber}>
          <div className={styles.multiLabelWithNumberLabel}>
            {multiLabelWithNumber}
          </div>
          <div className={styles.multiLabelWithNumberNumber}>
            {getValue().length}
          </div>
        </div>
      );
    }

    return null;
  }

  return <reactSelectComponents.MultiValue {...props} />;
};
